/* hihair Shop-Anpassungen v30 - erstellt von Claude

   NEU IN v30 (07.09.2026): STERNE IN DEN BEWERTUNGEN GOLD.
   Die Sterne im Bewertungs-Karussell (Klassen star-template--...) waren
   schwarz (#191818) bzw. die leeren fast unsichtbar (#f7f7f7).
   Jetzt: volle Sterne #FF9900 - genau der Ton, den die Judge.me-Sterne
   oben am Produkt schon haben - leere Sterne dezentes Grau, damit man
   4 von 5 auch erkennt.

   v29 (05.09.2026): Der Beobachter, der auf JEDE DOM-Aenderung der ganzen
   Seite reagiert hat (auf document.body mit childList+subtree), ist ENTFERNT,
   ebenso die Aufraeum-Funktion fuer das alte selbstgebaute x.
   REGEL: Nie wieder einen MutationObserver auf document.body.

   0) NUR EIN WARENKORB - ueber die Theme-Einstellung, NICHT per JS.
      In config/settings_data.json unter platform_customizations.custom_css:
          #HeaderCart {display: none !important;}
      REGEL: Am Oeffnen/Schliessen des Warenkorbs wird per JS NICHTS gemacht.

   5) KLAVIYO-TEASER (roter Balken): HIER PASSIERT NICHTS MEHR.

   1) GESCHENKE-FORTSCHRITTSLEISTE: AUSGEBLENDET (HIDE_PROGRESS)
   1b) GESCHENKE-BLOCK IM WARENKORB: AUSGEBLENDET (HIDE_PRESENTS)
      WICHTIG: present_1 / present_2 duerfen NICHT geleert werden - ohne
      Produkt-Handle rendert der komplette Vue-Warenkorb nichts (Ausfall v87).

   2) PRIORISIERTER VERSAND: gruener Button mit Kaestchen + Hinzufuegen.
   3) BUTTONS VEREINHEITLICHT auf BTN_GREEN + BTN_RADIUS.
   4) USP Guenstiger als zwei Einzelgeraete entfernt. */
(function () {
  var HIDE_PROGRESS = true;
  var HIDE_PRESENTS = true;

  var BTN_GREEN = '#35b97e';
  var BTN_GREEN_HOVER = '#2ba06c';
  var BTN_RADIUS = '10px';

  var STERN_VOLL = '#ff9900';
  var STERN_LEER = '#e2ded8';

  var USP_ENTFERNEN = ['Günstiger als zwei Einzelgeräte'];

  var SI = 'floow-vue-cart-JT-work';
  var STATUS_GREEN = '#2fb344';
  var INFO_ORANGE = '#f5820c';
  var BRAND_DARK = '#191818';
  var MODAL_IMG_WIDTH = 400;
  var STAGES = [
    { label: 'Kostenloser Versand', amount: '30 €', kind: 'shipping',
      benefit: 'Ab einem Bestellwert von 30 € liefern wir versandkostenfrei.' },
    { label: 'Aktivkohle Pulver WonderSmile', amount: '100 €', kind: 'gift', value: '17,90 €',
      benefit: 'Wird ab 100 € Bestellwert automatisch gratis in deine Bestellung gelegt.' },
    { label: 'Bleaching Set', amount: '300 €', kind: 'gift', value: '29,99 €',
      benefit: 'Wird ab 300 € Bestellwert automatisch gratis in deine Bestellung gelegt.' }
  ];

  var hideCss = '.shipping-bar-' + SI + '{display:none !important;}';
  var presentsCss = '.presents-' + SI + '{display:none !important;}';

  /* Sterne im Bewertungs-Karussell einfaerben */
  var sterneCss = ''
    + '[class*="star-template--"][class*="full-template--"]{color:' + STERN_VOLL + ' !important;}'
    + '[class*="star-template--"][class*="empty-template--"]{color:' + STERN_LEER + ' !important;}';

  var btnCss = ''
    + '.btn.add-to-cart, .checkout-button-' + SI + ', .shipping-button-' + SI + '{'
    + 'background:' + BTN_GREEN + ' !important;color:#fff !important;border-color:' + BTN_GREEN + ' !important;'
    + 'border-radius:' + BTN_RADIUS + ' !important;}'
    + '.btn.add-to-cart:hover, .checkout-button-' + SI + ':hover, .shipping-button-' + SI + ':hover{'
    + 'background:' + BTN_GREEN_HOVER + ' !important;border-color:' + BTN_GREEN_HOVER + ' !important;}'
    + '.express-shipping-' + SI + '{cursor:pointer;}'
    + '.shipping-button-' + SI + '{display:inline-flex !important;align-items:center;gap:7px;white-space:nowrap;'
    + 'padding:9px 13px !important;font-weight:700 !important;font-size:13px !important;line-height:1 !important;'
    + 'cursor:pointer !important;opacity:1 !important;border:0 !important;'
    + 'box-shadow:0 1px 3px rgba(0,0,0,.18);transition:background .15s ease,transform .1s ease;}'
    + '.shipping-button-' + SI + '::before{content:"";order:-2;flex:0 0 auto;width:15px;height:15px;'
    + 'border:2px solid #fff;border-radius:4px;background:transparent;}'
    + '.shipping-button-' + SI + '::after{content:"Hinzuf\\00FCgen";order:-1;}'
    + '.shipping-button-' + SI + ':active{transform:scale(.97);}'
    + '@media only screen and (max-width: 480px){'
    + '  .shipping-button-' + SI + '{font-size:12px !important;padding:8px 11px !important;gap:6px;}'
    + '  .shipping-button-' + SI + '::before{width:14px;height:14px;}'
    + '}';

  var css = ''
    + '.progress-bar-' + SI + '{height:8px !important;border-radius:8px !important;background:#ececec !important;margin-bottom:70px !important;}'
    + '.progress-' + SI + '{border-radius:8px !important;}'
    + '.circle-' + SI + '{overflow:visible !important;top:-21px !important;box-shadow:0 1px 4px rgba(0,0,0,.12);}'
    + '.circle-' + SI + ' img{border-radius:50%;}'
    + '.cgp-label{position:absolute;top:calc(100% + 6px);left:50%;transform:translateX(-50%);text-align:center;font-size:10.5px;line-height:1.2;white-space:normal;width:88px;overflow-wrap:break-word;word-break:break-word;-webkit-hyphens:auto;hyphens:auto;color:' + BRAND_DARK + ';}'
    + '.cgp-label strong{display:block;font-size:11px;font-weight:700;}'
    + '.cgp-label span.cgp-amount{display:block;color:#767676;}'
    + '.cgp-i-btn{position:absolute;top:-4px;left:-4px;z-index:3;display:inline-flex;align-items:center;justify-content:center;width:17px;height:17px;border:1.5px solid #fff;border-radius:50%;font-size:11px;font-weight:700;line-height:1;cursor:pointer;background:' + INFO_ORANGE + ';color:#fff;font-style:italic;font-family:Georgia,serif;pointer-events:auto;box-shadow:0 1px 3px rgba(0,0,0,.3);}'
    + '.cgp-i-btn::before{content:"";position:absolute;top:50%;left:50%;width:36px;height:36px;transform:translate(-50%,-50%);}'
    + '.cgp-i-btn:hover, .cgp-i-btn.cgp-i-active{background:' + BRAND_DARK + ';}'
    + '.cgp-modal-overlay{display:none;position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:99998;align-items:center;justify-content:center;padding:20px;}'
    + '.cgp-modal-overlay.cgp-open{display:flex;}'
    + '.cgp-modal{position:relative;background:#fff;border-radius:16px;padding:32px 28px 28px;max-width:340px;width:100%;text-align:center;box-shadow:0 10px 40px rgba(0,0,0,.25);}'
    + '.cgp-modal-close{position:absolute;top:12px;right:14px;width:28px;height:28px;display:flex;align-items:center;justify-content:center;border:none;background:transparent;font-size:18px;line-height:1;cursor:pointer;color:' + BRAND_DARK + ';}'
    + '.cgp-modal-media{width:160px;height:160px;margin:0 auto 16px;display:flex;align-items:center;justify-content:center;}'
    + '.cgp-modal-media img{max-width:100%;max-height:100%;object-fit:contain;border-radius:12px;}'
    + '.cgp-modal-media.cgp-modal-icon{font-size:64px;}'
    + '.cgp-modal-badge{color:' + INFO_ORANGE + ';font-weight:700;font-size:13px;letter-spacing:.02em;margin-bottom:6px;text-transform:uppercase;}'
    + '.cgp-modal-title{font-size:17px;font-weight:700;margin-bottom:6px;color:' + BRAND_DARK + ';}'
    + '.cgp-modal-value{font-size:12.5px;color:#767676;margin-bottom:10px;}'
    + '.cgp-modal-text{font-size:13px;line-height:1.5;color:#4a4a4a;}'
    + '@media only screen and (max-width: 480px){'
    + '  .cgp-label{font-size:8.5px;top:calc(100% + 5px);width:62px;}'
    + '  .cgp-label strong{font-size:9px;}'
    + '  .cgp-i-btn{width:15px;height:15px;font-size:10px;}'
    + '  .cgp-i-btn::before{width:32px;height:32px;}'
    + '  .cgp-modal{max-width:280px;padding:26px 20px 22px;}'
    + '  .cgp-modal-media{width:120px;height:120px;}'
    + '  .progress-bar-' + SI + '{margin-bottom:68px !important;}'
    + '}';

  function injectCss(rules) {
    var existing = document.getElementById('cgp-styles');
    if (existing) existing.remove();
    var s = document.createElement('style');
    s.id = 'cgp-styles';
    s.textContent = rules;
    (document.head || document.documentElement).appendChild(s);
  }

  function removeUsps() {
    if (!USP_ENTFERNEN.length) return;
    var items = document.querySelectorAll('[class*="usp-container"] li');
    for (var i = 0; i < items.length; i++) {
      var t = (items[i].textContent || '').replace(/\s+/g, ' ').trim();
      for (var j = 0; j < USP_ENTFERNEN.length; j++) {
        if (t === USP_ENTFERNEN[j]) { items[i].remove(); break; }
      }
    }
  }

  function hidePresents() {
    if (!HIDE_PRESENTS) return;
    var els = document.querySelectorAll('.presents-' + SI);
    for (var i = 0; i < els.length; i++) {
      els[i].style.setProperty('display', 'none', 'important');
    }
  }

  function hideProgressBlock() {
    var bar = document.querySelector('.progress-bar-' + SI);
    if (!bar) return;
    var target = bar.closest('.shipping-bar-' + SI);
    if (!target) {
      target = bar;
      var node = bar.parentElement;
      for (var i = 0; i < 4 && node; i++) {
        if (/Geschenke freischalten|Nur noch|bis zum/i.test(node.textContent || '')) { target = node; break; }
        node = node.parentElement;
      }
    }
    if (target.style.display !== 'none') target.style.display = 'none';
  }

  function fillRatio(bar) {
    var fill = bar.querySelector('.progress-' + SI);
    if (!fill || !bar.offsetWidth) return 0;
    return fill.offsetWidth / bar.offsetWidth;
  }

  function circleRatio(c) {
    var l = parseFloat((c.style.left || '0').replace('%', ''));
    return isNaN(l) ? 0 : Math.min(l, 100) / 100;
  }

  function bigImageUrl(src) {
    if (!src) return src;
    if (/[?&]width=\d+/.test(src)) {
      return src.replace(/([?&])width=\d+/, '$1width=' + MODAL_IMG_WIDTH);
    }
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + MODAL_IMG_WIDTH;
  }

  function getOrCreateModal() {
    var overlay = document.querySelector('.cgp-modal-overlay');
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'cgp-modal-overlay';
    overlay.innerHTML = '<div class="cgp-modal"><button type="button" class="cgp-modal-close" aria-label="Schliessen">✕</button><div class="cgp-modal-body"></div></div>';
    document.body.appendChild(overlay);
    return overlay;
  }

  function openModal(idx, circles) {
    var st = STAGES[idx];
    if (!st) return;
    var overlay = getOrCreateModal();
    var body = overlay.querySelector('.cgp-modal-body');
    var img = circles[idx] ? circles[idx].querySelector('img') : null;
    var mediaHtml = img
      ? '<div class="cgp-modal-media"><img src="' + bigImageUrl(img.src) + '" alt=""></div>'
      : '<div class="cgp-modal-media cgp-modal-icon">📦</div>';
    var badgeHtml = st.kind === 'shipping'
      ? '<div class="cgp-modal-badge">AB ' + st.amount + '</div>'
      : '<div class="cgp-modal-badge">GRATIS AB ' + st.amount + '</div>';
    var valueHtml = st.value ? '<div class="cgp-modal-value">Wert: ' + st.value + '</div>' : '';
    body.innerHTML = mediaHtml + badgeHtml +
      '<div class="cgp-modal-title">' + st.label + '</div>' + valueHtml +
      '<div class="cgp-modal-text">' + st.benefit + '</div>';
    overlay.classList.add('cgp-open');
  }

  function closeModal() {
    var overlay = document.querySelector('.cgp-modal-overlay');
    if (overlay) overlay.classList.remove('cgp-open');
    document.querySelectorAll('.cgp-i-btn').forEach(function (b) { b.classList.remove('cgp-i-active'); });
  }

  function enhance() {
    removeUsps();
    hidePresents();
    if (HIDE_PROGRESS) { hideProgressBlock(); return; }
    var bar = document.querySelector('.progress-bar-' + SI);
    if (!bar) return;
    var circles = bar.querySelectorAll('.circle-' + SI);
    if (!circles.length) return;
    var fr = fillRatio(bar);
    circles.forEach(function (c, i) {
      var st = STAGES[i];
      if (!st) return;
      var unlocked = fr + 0.005 >= circleRatio(c);
      c.style.border = unlocked ? '3px solid ' + STATUS_GREEN : '3px solid #e3e3e3';
      if (!c.querySelector('.cgp-i-btn')) {
        var iBtn = document.createElement('span');
        iBtn.className = 'cgp-i-btn';
        iBtn.setAttribute('data-cgp-i', i);
        iBtn.setAttribute('role', 'button');
        iBtn.setAttribute('tabindex', '0');
        iBtn.setAttribute('aria-label', 'Was ist das?');
        iBtn.textContent = 'i';
        c.appendChild(iBtn);
      }
      var existingLabel = c.querySelector('.cgp-label');
      var labelHtml = '<strong>' + st.label + '</strong><span class="cgp-amount">ab ' + st.amount + '</span>';
      if (!existingLabel) {
        var label = document.createElement('span');
        label.className = 'cgp-label';
        label.innerHTML = labelHtml;
        c.appendChild(label);
      } else if (existingLabel.innerHTML !== labelHtml) {
        existingLabel.innerHTML = labelHtml;
      }
    });
  }

  document.addEventListener('click', function (e) {
    if (HIDE_PROGRESS) {
      if (e.target.closest && e.target.closest('.cgp-modal-close')) { e.preventDefault(); closeModal(); }
      return;
    }
    var iBtn = e.target.closest && e.target.closest('.cgp-i-btn');
    if (iBtn) {
      e.preventDefault();
      e.stopPropagation();
      var idx = parseInt(iBtn.getAttribute('data-cgp-i'), 10);
      var bar = document.querySelector('.progress-bar-' + SI);
      if (!bar) return;
      var circles = bar.querySelectorAll('.circle-' + SI);
      document.querySelectorAll('.cgp-i-btn').forEach(function (b) { b.classList.remove('cgp-i-active'); });
      iBtn.classList.add('cgp-i-active');
      openModal(idx, circles);
      return;
    }
    if (e.target.closest && e.target.closest('.cgp-modal-close')) {
      e.preventDefault();
      closeModal();
      return;
    }
    if (e.target.classList && e.target.classList.contains('cgp-modal-overlay')) {
      closeModal();
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  function start() {
    enhance();
    var bar = document.querySelector('.progress-bar-' + SI);
    var observeTarget = bar ? bar.closest('#cart-' + SI) || bar : null;
    if (observeTarget) {
      var scheduled = false;
      function scheduleEnhance() {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () { scheduled = false; enhance(); });
      }
      var observer = new MutationObserver(scheduleEnhance);
      observer.observe(observeTarget, { attributes: true, childList: true, subtree: true });
    }
    setInterval(enhance, 3000);
  }

  injectCss((HIDE_PROGRESS ? hideCss : css) + (HIDE_PRESENTS ? presentsCss : '') + btnCss + sterneCss);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
